import React, {ReactElement, ReactNode} from 'react';
import Header from '../Header/Header';
import Footer from '../../Footer/Footer';

import './GeneralLayout.scss';

interface Props {
  children: ReactNode;
  focusMode?: boolean;
}

function GeneralLayout({children, focusMode}: Props): ReactElement {
  return (
    <div className="generalLayout">
      <Header showLinks focusMode={focusMode} />
      <div className="generalLayout__inner">{children}</div>
      <Footer />
    </div>
  );
}

export default GeneralLayout;
